import { createReducer } from "typesafe-actions";
import { sendSupplierOfferFileAsync, getSupplierProductsMappingsAsync, updateSupplierProductsMappingsAsync, updatePrices, updateSupplierDeliveryTimesAsync, getSupplierInfoAsync, removeSupplierDeliveryTimeAsync, sendCatalogUpdatePropositionAsync, getSupplierOrdersAsync } from "../actions/SupplierActions";
import { SupplierProductMapping } from "../../api/models/SupplierProductMapping";
import { Throwing } from "../../models/common";
import { SupplierDeliveryTime } from "../../api/models/SupplierDeliveryTime";
import { Supplier } from "../../api/models/QuotedData";
import moment from "moment";
import { SupplierOrders } from "../apiModels";

interface SupplierState extends Throwing {
    supplierId: number | null,

    sendSupplierOfferBusy: boolean,
    sendSupplierOfferSucced: boolean | null,

    suppProdsMappingsBusy: boolean,
    supplierProductsMappings: SupplierProductMapping[] | null,
    updateMappingsBusy: boolean,
    updateMappingSuccess: boolean | null,

    updateDeliveryTimesBusy: boolean,
    supplierDeliveryTimes: SupplierDeliveryTime[] | null

    getSupplierInfoBusy: boolean,
    supplierInfo: Supplier | null

    sendCatUpdatePropBusy: boolean

    getSupplierOrdersBusy: boolean
    supplierOrders: SupplierOrders | null 
}

const initialState: SupplierState = {
    supplierId: null,

    sendSupplierOfferBusy: false,
    sendSupplierOfferSucced: null,

    suppProdsMappingsBusy: false,
    supplierProductsMappings: null,
    updateMappingsBusy: false,
    updateMappingSuccess: null,

    updateDeliveryTimesBusy: false,
    supplierDeliveryTimes: null,

    getSupplierInfoBusy: false,
    supplierInfo: null,

    sendCatUpdatePropBusy: false,

    getSupplierOrdersBusy: false,
    supplierOrders: null,
}

const orderReducer = createReducer(initialState)

    .handleAction(getSupplierInfoAsync.request, (state) => { return { ...state, getSupplierInfoBusy: true } })
    .handleAction(getSupplierInfoAsync.success, (state, action) => {
        let deliveryTimes = action.payload.deliveryTimes ? action.payload.deliveryTimes : []
        return { ...state, supplierInfo: action.payload, supplierDeliveryTimes: deliveryTimes, getSupplierInfoBusy: false }
    })
    .handleAction(getSupplierInfoAsync.failure, (state, action) => {
        return { ...state, error: action.payload, getSupplierInfoBusy: false }
    })


    .handleAction(getSupplierProductsMappingsAsync.request, (state) => { return { ...state, suppProdsMappingsBusy: true } })
    .handleAction(getSupplierProductsMappingsAsync.success, (state, action) => {
        let mappings = action.payload.map(m => { return { ...m, _isMapped: isMapped(m) } })
        return { ...state, suppProdsMappingsBusy: false, supplierProductsMappings: mappings }
    })
    .handleAction(getSupplierProductsMappingsAsync.failure, (state, action) => {
        return { ...state, suppProdsMappingsBusy: false, error: action.payload }
    })

    .handleAction(updateSupplierProductsMappingsAsync.request, (state) => { return { ...state, updateMappingsBusy: true, updateMappingSuccess: null } })
    .handleAction(updateSupplierProductsMappingsAsync.success, (state, action) => {
        //If there was an success, update also locally using same array:
        let mappings = state.supplierProductsMappings!.slice()
        for (let m of action.payload) {
            let elementIdx = mappings.findIndex(spm => spm.supplierProductId === m.supplierProductId && spm.supplierId === m.supplierId)
            mappings[elementIdx] = { ...m, _isMapped: isMapped(m), _isDirty: false }
        }

        return { ...state, updateMappingsBusy: false, updateMappingSuccess: true, supplierProductsMappings: mappings }
    })
    .handleAction(updateSupplierProductsMappingsAsync.failure, (state, action) => {
        return { ...state, updateMappingsBusy: false, updateMappingSuccess: false, error: action.payload }
    })

    .handleAction(sendSupplierOfferFileAsync.request, (state) => { return { ...state, sendSupplierOfferSucced: null, sendSupplierOfferBusy: true } })
    .handleAction(sendSupplierOfferFileAsync.success, (state) => { return { ...state, sendSupplierOfferSucced: true, sendSupplierOfferBusy: false } })
    .handleAction(sendSupplierOfferFileAsync.failure, (state, action) => {
        return { ...state, error: action.payload, sendSupplierOfferSucced: false, sendSupplierOfferBusy: false }
    })


    .handleAction(updateSupplierDeliveryTimesAsync.request, (state) => { return { ...state, updateDeliveryTimesBusy: true } })
    .handleAction(updateSupplierDeliveryTimesAsync.success, (state, action) => { return { ...state, supplierDeliveryTimes: action.payload, updateDeliveryTimesBusy: false } })
    .handleAction(updateSupplierDeliveryTimesAsync.failure, (state, action) => {
        return { ...state, error: action.payload, updateDeliveryTimesBusy: false }
    })

    .handleAction(removeSupplierDeliveryTimeAsync.request, (state) => { return { ...state, updateDeliveryTimesBusy: true } })
    .handleAction(removeSupplierDeliveryTimeAsync.success, (state, action) => { return { ...state, supplierDeliveryTimes: action.payload, updateDeliveryTimesBusy: false } })
    .handleAction(removeSupplierDeliveryTimeAsync.failure, (state, action) => {
        return { ...state, error: action.payload, updateDeliveryTimesBusy: false }
    })

    .handleAction(sendCatalogUpdatePropositionAsync.request, (state) => { return { ...state, sendCatUpdatePropBusy: true } })
    .handleAction(sendCatalogUpdatePropositionAsync.success, (state) => { return { ...state, sendCatUpdatePropBusy: false } })
    .handleAction(sendCatalogUpdatePropositionAsync.failure, (state, action) => {
        return { ...state, error: action.payload, sendCatUpdatePropBusy: false }
    })


    .handleAction(getSupplierOrdersAsync.request, (state) => { return { ...state, getSupplierOrdersBusy: true } })
    .handleAction(getSupplierOrdersAsync.success, (state, action) => { return { ...state, supplierOrders: action.payload, getSupplierOrdersBusy: false } })
    .handleAction(getSupplierOrdersAsync.failure, (state, action) => {
        return { ...state, error: action.payload, getSupplierOrdersBusy: false }
    })
    

    .handleAction(updatePrices, (state, action) => {
        return { ...state, supplierProductsMappings: updateObjectInArray(state.supplierProductsMappings!.slice(), action.payload) }
    })


function updateObjectInArray(array: SupplierProductMapping[] | null, action: SupplierProductMapping): SupplierProductMapping[] | null {
    if (array === null)
        return null
    else
        return array.map((item) => {
            if (item.supplierProductId !== action.supplierProductId) {
                return item
            }
            else
                return {
                    ...item,
                    ...action
                }
        })
}


function isMapped(m: SupplierProductMapping): boolean {
    return (m.catalogueProductId !== '' && (m.boxingType !== '0' && m.boxingType !== '') && m.mappingStatus === "CONFIRMED")
}

export function toDeliveryTimes(dts: SupplierDeliveryTime[] | null): SupplierDeliveryTime[]{
    if(dts !== null)
    for(let dt of dts){
        dt.startTime = moment.duration(dt.startTime)
        dt.endTime = moment.duration(dt.endTime)
    }
    return dts || []
}

export default orderReducer;